import type { ComponentPortal } from "@angular/cdk/portal";
import type { ApplicationRef, ComponentRef, Injector } from "@angular/core";


export abstract class PplPopoverPortalOutletFactory {

  abstract create(
    outletElement: Element,
    appRef: ApplicationRef,
    defaultInjector: Injector
  ): PplPopoverPortalOutlet;
}

export abstract class PplPopoverPortalOutlet {
  abstract attachComponentPortal<T>(portal: ComponentPortal<T>): ComponentRef<T>;
  abstract detach(): void;
}
